import React from 'react';
import { Fragment } from 'react';
import Header from '../../components/header'
import Footer from '../../components/footer';
import Pesquisa from '../../components/pesquisa/form_cad';
import Head from '../../components/head';
import { Container } from 'react-bootstrap';


function PesquisaScreen() {
    return (
        <Fragment>
            <Head titulo="Pesquisa de satisfação com serviços públicos prestados pela Prefeitura de Macuco" />
            <Header />
            <Container>
                <Pesquisa />
            </Container>
            <Footer />
        </Fragment>
    );
}

export default PesquisaScreen;